var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGi = function SvgGi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#da000c",
    d: "M0 0h512v256H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v171.5H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gi_svg__a",
    fill: "#da000c",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "none",
    d: "M196.571 116.303h64v43.993h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.819 153.865H190.75l-8.66 5.7v6.04h47.729m-16.35-37.011c5.625 0 10.219 4.689 10.219 10.469v14.78h7.343v-56H190.75v56h12.5v-14.78c0-5.554 4.515-10.47 10.219-10.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "none",
    d: "M204.528 59.962h18.523v33.959h-18.523z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223 88.656h-16.209v-5.75h-11.885v5.75h-8.062v-5.75h-4.813v10.438H223m-36.156-.038h34.97v4.538h-34.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.719 47.625v35.281h6.072V73.22c0-3.63 2.562-6.6 6.147-6.781.115-.006.226 0 .343 0a6.78 6.78 0 0 1 6.781 6.78v9.688h5.782V47.625zm-2.188-4.781v4.781h29.25v-4.781zm-3.75-9.156v9.156h35.094v-9.157h-5.406v4.657h-6.531v-4.657h-9.97v4.657h-6.53v-4.657zM182.09 159.564H230m31-2.751h-32.438l-9.78 4.718v7.031H261"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    d: "M218.771 161.52H262"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gi_svg__a",
    transform: "matrix(-1 0 0 1 512 0)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f8d80e"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.768,
    d: "M273.297 150.031c-2.654.883-5.053 2.369-7.469 3.753-3.1 1.831-6.107 3.827-8.904 6.099-.985.649-1.93 1.36-2.69 2.273-1.025.878-2.064 2.055-1.868 3.513.051.643.873-.755 1.414-.823a4.4 4.4 0 0 1 3.142-.471c1.271-1.339 2.91-2.236 4.325-3.406 3.004-2.243 6.236-4.168 9.525-5.961 1.148-.589 2.3-1.186 3.525-1.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.4 157.391v3.912m2.417-5.618v3.883m2.416-5.388v3.858m2.417-5.344v3.981"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.768,
    d: "m238.891 150.156-1.188 3.313c5.537 2.1 10.81 4.878 15.798 8.06 1.691 1.15 3.467 2.266 4.796 3.846.293.81-.514 1.489-1.314 1.244-.732-.249-1.453-.532-2.226-.004-1.107.503-2.106 2.141-.426 2.69 2.315 1.556 6.082.88 7.195-1.844.581-1.402.618-3.196-.508-4.345-2.063-2.364-4.797-4.008-7.421-5.672-4.69-2.82-9.573-5.374-14.706-7.288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.05 158.035-.313 3.34m3.095-1.635-.862 3.269m3.834-.997-1.808 2.537m2.719 3.631-2.61-1.4m3.423-1.351-2.995.28m-.868 4.056-.205-2.633m-.892-.376-2.473 1.822m-9.418-15.641v3.115m6.286.192v3.534m-3.143-5.185v3.32"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.781 227.563v8.03h5.031v-4.03h6.844v4.03h5.406v-8.03zm0 11.062v8.063h17.281v-8.063h-5.406v4.031h-6.844v-4.031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.052 193.651h4.99v58.115h-4.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.052 198.679h4.99v50.06h-4.99z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.024,
    d: "m255.547 179.406 10.625 6.188-10.625 6.156-10.625-6.156zm-14.219 3.969h-2.781v4.438h2.781l14.219 8.25 14.219-8.25h2.78v-4.438h-2.78l-14.22-8.25z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.024,
    d: "M255.344 164.281c-2.419.34-4.226 2.73-4.094 5.134.01 3.738-.018 7.476.014 11.214.129 2.408 2.233 4.566 4.675 4.588 1.985.188 3.979-.972 4.811-2.78l-1.718-1.031c-.444 1.184-1.724 1.918-2.97 1.781-1.634.046-2.958-1.544-2.812-3.134.01-3.713-.019-7.428.015-11.14.09-1.516 1.535-2.755 3.048-2.6.626-.18 1.487.676 1.875-.063.583-.83-.415-1.477-.97-1.937-.613-.085-1.253-.008-1.874-.032zm5.781 3.906c-.396.746-1.216 1.19-1.875 1.58v7.514l2 1.156c-.008-3.204.016-6.408-.011-9.611-.032-.197-.008-.499-.114-.639z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#da000c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "none",
    d: "M240.803 38.351h29.329v53.255h-29.329z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.75 38.375v44.563h9.313v-13.22c0-3.048 1.952-7.28 7.937-7.28s7.938 4.232 7.938 7.28v13.22h9.312V38.374zm15.813 5h2.875v15.25h-2.875zm-8.25 3h2.906v11.156h-2.906zm16.468 0h2.906v11.156h-2.906zm-27.187-14.406v6.343h40.812V31.97zm-3.844-7.375v7.375h48.5v-7.375h-6.094v4.062h-6.875v-4.062h-7.844v4.062h-6.875v-4.062h-7.843v4.062h-6.875v-4.062zm-9 73.25v4.594h66.5v-4.594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.031 82.906v14.938h71.938V82.906h-6.813v5.75h-9.062v-5.75h-12.156v5.75h-15.875v-5.75h-12.157v5.75h-9.062v-5.75z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M228.688 102.438v54.343h12.843v-20.344c0-9.582 6.397-14.093 14.469-14.093 7.759 0 14.469 4.51 14.469 14.094v20.343h12.844v-54.344z"
  })))));
};
export default SvgGi;